<!--
 * @Description: 重命名
 * @Author: luocheng
 * @Date: 2022-03-02 15:50:16
 * @LastEditors: 吴绍鹏 542278473@qq.com
 * @LastEditTime: 2023-09-14 09:45:22
-->
<template>
  <div class="rename" v-if="value">
    <el-dialog
      :title="title"
      :visible.sync="value"
      :show-close="false"
      :before-close="handleClose"
      append-to-body
      width="400px">
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="url">
          <el-input v-model="form.url" placeholder="请输入名称" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose">取 消</el-button>
        <el-button type="primary" @click="onConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Rename',
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    inputData: {
      type: Object,
      required: false,
      default() {
        return {}
      }
    },
    type: {
      type: String,
      required: false,
      default: 'create'
    }
  },
  data() {
    const validateEmpty = (rules, value, callback) => {
      if(!value || !value.trim()) {
        callback(new Error('不能为空'))
      } else {
        callback();
      }
    }
    return {
      form: {
        name: '',
        url: ''
      },
      rules: {
        name: [
          // { required: true, message: '请输入名称', trigger: 'blur' },
          { validator: validateEmpty, message: '请输入名称', trigger: 'blur' }
        ],
        url: [
          // { required: true, message: '请输入链接', trigger: 'blur' },
          { validator: validateEmpty, message: '请输入名称', trigger: 'blur' }
        ],
      }
    }
  },
  watch: {
    value: {
      handler() {
        this.form.name = this.inputData.name;
        this.form.url = this.inputData.url || this.inputData.path;
      }
    }
  },
  computed: {
    title() {
      return this.type === 'create' ? '新增链接' : '编辑链接';
    }
  },
  created() {
    this.form.name = this.inputData.name;
    this.form.url = this.inputData.url || this.inputData.path;
  },
  methods: {
    handleClose(done) {
      this.onClose();
      done();
    },
    onClose() {
      this.name = '';
      this.$emit('input', false)
    },
    onConfirm() {
      this.$refs.form.validate((valid) => {
        if(valid) {
          // 兼容 path 及 url
          this.form.path = this.form.url
          this.$emit('submit', this.form);
        }
      })
    }
  },
}
</script>

<style lang="less" scoped>
.rename{
  :deep(.el-dialog){
    .el-dialog__header{
      text-align: left;
      border-bottom: 1px solid #f5f5f5;
      .el-dialog__title{
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
}
</style>